export default __webpack_public_path__ + "static/media/filling_gap.9b4a1884.svg";